import { sprintf } from 'sprintf-js';

export function cmsGetDonateBlockSubmitButtonText(amount?: string) {
  if (amount) {
    return sprintf(getText('Donate $%(amount)s USD'), {
      amount: amount.toString(),
    });
  }
  return getText('Donate');
}
